<app-layout>
  <div class="container mt-4">
    <div>
      <app-card>
        <tabset
          [justified]="true"
          #staticTabs
        >
          <tab
            i18n-heading="@@user-administration"
            heading="Nutzerverwaltung"
          >
            <ng-container *ngTemplateOutlet="userListTpl"></ng-container>
          </tab>
          <tab
            i18n-heading="@@transfer-protocols"
            heading="Transferprotokolle"
          >
            <ng-container *ngTemplateOutlet="protocolListTpl"></ng-container>
          </tab>
        </tabset>
      </app-card>
    </div>
  </div>

  <ng-template #userListTpl>
    <div class="text-end">
      <div
        class="btn btn-sm btn-primary my-3"
        (click)="modalRef = modalService.show(addUserModal)"
        i18n="@@new-user"
      >
        Neuer Nutzer
      </div>
    </div>
    <!-- Todo: Translated labels-->
    <lib-rag-datasupply-table-quicklook-aside
      [overrideTableClasses]="''"
      #table
      [service]="this.frontendService"
      [columns]="[
                { fieldName: 'name', label: 'Name' },
                { fieldName: 'email', label: 'E-Mail' }
              ]"
      [translatedLabels]="this.translatedLabels"
      i18n-noDataText="@@no-users"
      noDataText="Keine Nutzer vorhanden."
    >
      <ng-container *ngIf="table.selectedObject">
        <div class="px-3">
          <div class="form-group mb-2">
            <label
              for="name"
              i18n="@@name"
            >Name</label>
            <input
              type="text"
              class="form-control"
              id="name"
              name="name"
              [(ngModel)]="table.selectedObject.name"
              (ngModelChange)="editUser(table.selectedObject._id, { name: $event })"
            />
          </div>
          <div class="form-group mb-2">
            <label
              for="email"
              i18n="@@email"
            >E-Mail</label>
            <input
              type="email"
              class="form-control"
              id="email"
              name="email"
              [(ngModel)]="table.selectedObject.email"
              (ngModelChange)="
                    editUser(table.selectedObject._id, { email: $event })
                  "
            />
          </div>
          <div class="form-check mb-2">
            <input
              #input
              class="form-check-input"
              type="checkbox"
              id="useradmin"
              [ngModel]="table.selectedObject?.permissions?.includes('admin')"
              (ngModelChange)="editUser(table.selectedObject._id, {
                        isAdmin: !table.selectedObject?.permissions?.includes('admin')
                      })"
            />
            <label
              class="form-check-label"
              for="useradmin"
              i18n="@@user-admin"
            >Nutzeradmin</label>&nbsp;<i
              class="ri-question-line text-primary"
              i18n-tooltip="@@user-admin-tooltip"
              tooltip="Nutzeradmins können alle Räume & Nutzer editieren und die Globalen Einstellungen anpassen."
            ></i>
          </div>
          <div class="row mb-4">
            <div class="col-auto">
              <div
                class="btn btn-danger"
                (click)="modalRef = this.modalService.show(confirmDelete)"
                i18n="@@delete-user"
              >Nutzer löschen</div>
            </div>
            <div class="col-auto">
              <div
                class="btn btn-primary"
                (click)="modalRef = this.modalService.show(confirmInvite)"
                i18n="@@invite-user"
              >Nutzer einladen</div>
            </div>
          </div>
          <div class="form-group mb-2">
            <label
              for="selectTransfer"
              i18n="@@room-transfer"
            >Räume an anderen Nutzer übertragen</label>
            <select
              id="selectTransfer"
              class="form-select"
              [(ngModel)]="this.selectedUserForRoomTransfer"
              [ngModelOptions]="{updateOn: 'change'}"
            >
              @for (user of this.getUsersWithoutOwnUser(table.selectedObject._id); track $index) {
              <option [value]="user._id">{{ user.name }}</option>
              }
            </select>
          </div>
          <div class="form-check mb-2">
            <input
              #input
              class="form-check-input"
              type="checkbox"
              id="transfer-room-clearence"
              [ngModel]="this.shouldRoomTransferIncludeClearences"
              (ngModelChange)="this.shouldRoomTransferIncludeClearences = !this.shouldRoomTransferIncludeClearences"
            />
            <label
              class="form-check-label"
              for="transfer-room-clearence"
              i18n="@@transfer-room-clearence"
            >
              Raumfreigaben auch übertragen
            </label>
          </div>
          <button
            type="button"
            class="btn btn-outline-danger"
            (click)="this.preloadTransferChanges(table.selectedObject._id); modalRef = this.modalService.show(confirmRoomTransfer)"
            i18n="@@transfer-rooms-to-user"
          >
            Raumtransfer durchführen
          </button>
        </div>
      </ng-container>
    </lib-rag-datasupply-table-quicklook-aside>
    <ng-template #confirmDelete>
      <div class="modal-body">
        <div>
          <ng-container i18n="@@confirm-delete-user">Sind Sie sicher, dass Sie den Nutzer unwiderruflich löschen
            wollen?</ng-container>
          <div class="text-center">
            <div class="btn-group">
              <div
                class="btn btn-primary mt-2"
                (click)="modalRef.hide()"
                i18n="@@no"
              >Nein</div>
              <div
                class="btn btn-light mt-2"
                (click)="deleteUser(table.selectedObject._id)"
                i18n="@@yes"
              >Ja</div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #confirmInvite>
      <div class="modal-body">
        <div>
          <ng-container i18n="@@invite-selected-user">Nutzer {{table.selectedObject.name}} jetzt
            einladen?</ng-container>
          <div class="text-center">
            <div class="btn-group">
              <div
                class="btn btn-primary mt-2"
                (click)="modalRef.hide()"
                i18n="@@no"
              >Nein</div>
              <div
                class="btn btn-light mt-2"
                (click)="this.inviteUser(table.selectedObject._id)"
                i18n="@@yes"
              >Ja</div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #confirmRoomTransfer>
      <div class="modal-body">
        <div>
          @if (this.transferChanges.length !== 0) {
          <h3 i18n="@@transfer-action-confirm">
            Bitte bestätigen Sie folgende Aktion:
          </h3>
          <span>
            Bei dieser Aktion werden <b>alle Räume</b> des Nutzers "{{ table.selectedObject.name }}" an den Nutzer
            "{{ this.getUserForId().name }}" transferriert.
          </span>
          <br>
          <ng-container *ngIf="this.shouldRoomTransferIncludeClearences">
            Es werden dabei auch die vergebenen Raumfreigaben des Nutzers "{{ table.selectedObject.name }}"
            übertragen.
          </ng-container>
          <p>
            Folgende Räume sind von dem Transfer betroffen:
          </p>
          <div class="row">
            <div
              class="col"
              i18n="@@roomname"
            >
              Raumname
            </div>
            <div
              class="col-5"
              i18n="@@shared-or-owned"
            >
              Eigener Raum / Raumfreigabe
            </div>
          </div>
          }
          @else {
          <p i18n="@@transfer-action-fail">
            Der ausgewählte Nutzer hat keine eigenen Räume oder Raumfreigaben für einen Transfer.
          </p>
          }
          @for (changes of this.transferChanges; track $index) {
          <div class="row">
            <div class="col">
              {{ changes.roomName }}
            </div>
            <div class="col-3">
              <ng-container
                *ngIf="changes.type === 'share'"
                i18n="@@shared-room"
              >Raumfreigabe</ng-container>
              <ng-container
                *ngIf="changes.type === 'owner'"
                i18n="@@owners-room"
              >Eigener Raum</ng-container>
            </div>
          </div>
          }
          <div class="text-center">
            <div class="btn-group">
              <button
                class="btn btn-primary mt-2"
                (click)="modalRef.hide()"
                i18n="@@cancel"
              >Abbrechen</button>
              <button
                class="btn btn-light mt-2"
                (click)="this.transferRoomsToUser(table.selectedObject._id); modalRef.hide()"
                i18n="@@confirm-transfer"
                [disabled]="this.transferChanges.length === 0"
              >Transfer bestätigen</button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #addUserModal>
      <div class="modal-header">
        <h4
          class="modal-title pull-left"
          i18n="@@add-new-user"
        >Neuen Nutzer hinzufügen</h4>
        <button
          type="button"
          class="btn-close close pull-right"
          aria-label="Close"
          (click)="modalRef?.hide()"
        >
          <span
            aria-hidden="true"
            class="visually-hidden"
          >&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <div class="form-group">
            <label
              class="form-check-label"
              for="name"
              i18n="@@name"
            >Name</label>
            <input
              #name
              id="name"
              class="form-control"
              type="text"
              [(ngModel)]="newUser.name"
            />
          </div>
          <div class="form-group">
            <label
              class="form-check-label"
              for="email"
              i18n="@@email"
            >E-Mail</label>
            <input
              #email
              id="email"
              class="form-control"
              type="email"
              [(ngModel)]="newUser.email"
            />
          </div>
          <div class="form-check">
            <label
              class="form-check-label"
              for="newuseradmin"
              i18n="@@useradmin"
            >Nutzeradmin</label>&nbsp;<i
              class="ri-question-line text-primary"
              i18n-tooltip="@@useradmin-tooltip"
              tooltip="Nutzeradmins können alle Räume & Nutzer editieren und die Globalen Einstellungen anpassen."
            ></i>
            <input
              #isAdmin
              id="newuseradmin"
              class="form-check-input"
              type="checkbox"
              [(ngModel)]="newUser.isAdmin"
            />
          </div>
          <hr>
          <div class="form-check">
            <label
              class="form-check-label"
              for="inviteOnCreate"
              i18n="@@send-invite"
            >Einladung per E-Mail verschicken</label>
            <input
              id="inviteOnCreate"
              [(ngModel)]="this.inviteOnCreate"
              class="form-check-input"
              type="checkbox"
            >
          </div>
          <div
            class="btn btn-primary mt-2"
            (click)="addUser(); modalRef.hide()"
            i18n="@@create"
          >
            Erstellen
          </div>
        </div>
      </div>
    </ng-template>
  </ng-template>

  <ng-template #protocolListTpl>
    <div class="text-end">
      <button
        type="button"
        class="btn btn-sm btn-primary my-3"
        (click)="this.downloadAllTransfers()"
        i18n="@@export-transfer-protocols"
      >
        Export Transfer-Protokolle
      </button>
    </div>
    <table class="table table-hover">
      <thead>
        <tr>
          <th
            style="width: 30%"
            i18n="@@transfer-id"
          >
            Transfer ID
          </th>
          <th
            style="width: 30%"
            i18n="@@executed-at"
          >
            Ausgeführt am
          </th>
          <th
            style="width: 30%"
            i18n="@@executed-by"
          >
            Ausgeführt von
          </th>
          <th
            style="width: 10%"
            i18n="@@actions"
          >
            Aktionen
          </th>
        </tr>
      </thead>
      <tbody>
        @for (protocol of this.transferProtocols; track $index) {
        <tr>
          <td style="vertical-align: middle;">
            {{ protocol._id }}
          </td>
          <td style="vertical-align: middle;">
            {{ dayjs(protocol.transferDate).format("DD.MM.YYYY HH:mm") }}
          </td>
          <td style="vertical-align: middle;">
            {{ protocol.transferByName }}
          </td>
          <td>
            <button
              type="button"
              class="btn btn-sm"
              (click)="modalRef = modalService.show(showTransferDetailsModal, {initialState: { transferIndex: $index}})"
            >
              <i class="ri-search-line"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm"
              (click)="this.downloadSingleTransfers(protocol._id)"
            >
              <i class="ri-download-2-line"></i>
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>
    <ng-template #showTransferDetailsModal>
      <div class="modal-header">
        <div class="w-100">
          <h3 i18n="@@general-data">Allgemeine Daten</h3>
          <table class="mb-3">
            <tbody>
              <tr>
                <td
                  class="pe-2"
                  i18n="@@transfer-id"
                >Transfer ID: </td>
                <td>{{ this.getSingleTransferData()._id }}</td>
              </tr>
              <tr>
                <td
                  class="pe-2"
                  i18n="@@executed-at"
                >Ausgeführt am: </td>
                <td>{{ dayjs(this.getSingleTransferData().transferDate).format("DD.MM.YYYY HH:mm") }}</td>
              </tr>
              <tr>
                <td
                  class="pe-2"
                  i18n="@@executed-by"
                >Ausgeführt von: </td>
                <td>{{ this.getSingleTransferData().transferByName }}</td>
              </tr>
              <tr>
                <td
                  class="pe-2"
                  i18n="@@transfer-from"
                >Transferriert von: </td>
                <td>{{ this.getSingleTransferData().fromUserName }}</td>
              </tr>
              <tr>
                <td
                  class="pe-2"
                  i18n="@@transfer-to"
                >Transferriert nach: </td>
                <td>{{ this.getSingleTransferData().toUserName }}</td>
              </tr>
            </tbody>
          </table>
          <h3 i18n="@@affected-rooms">Betroffene Räume</h3>
          @for (room of this.getSingleTransferData().rooms; track $index) {
          <div class="row">
            <div class="col">
              {{ room.name }}
            </div>
            <div class="col-3">
              <ng-container
                *ngIf="room.transferType === 'share'"
                i18n="@@shared-room"
              >Raumfreigabe</ng-container>
              <ng-container
                *ngIf="room.transferType === 'owner'"
                i18n="@@owners-room"
              >Eigener Raum</ng-container>
            </div>
          </div>
          }
        </div>
      </div>
    </ng-template>
  </ng-template>
</app-layout>